import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const buildFaqs = (byId) => {
  const t1 = byId('basic'), t1a = byId('basic_annual'), t2 = byId('standard'), t3 = byId('featured');
  return [
    ['How am I billed?', <>Tier 1 Category Listing is a card subscription through Stripe: <b>{t1?.billing}</b> or <b>{t1a?.billing}</b>. Business Growth and Full Growth Campaign are paid securely through PayPal (card or PayPal balance).</>],
    ['What happens after the intro period?', <>Business Growth is <b>{t2?.billing}</b>. Full Growth Campaign is <b>{t3?.billing}</b>. You'll always see the renewal price at checkout before you pay.</>],
    ['Do plans renew automatically?', <>Yes. Tier 1 renews automatically every 6 or 12 months, depending on the option you picked. Monthly plans renew each month, so your listing and features stay active without interruption.</>],
    ['Can I cancel?', <>Yes, you can cancel anytime. Your listing and plan features stay active until the end of the period you've already paid for, and you won't be charged again. To cancel, contact PBB support from your dashboard.</>],
    ['Can I upgrade later?', <>Absolutely. Start with a Category Listing and upgrade to Business Growth or Full Growth Campaign anytime from <b>Business → Upgrade</b> in your dashboard.</>],
    ['Do I need an account before paying?', <>No. Pay first, then you'll go straight to a quick sign-up form. Your plan is applied automatically to the first business you register.</>],
  ];
};

export const PlanFAQ = ({ byId }) => (
  <section className="bg-white rounded-2xl p-5 md:p-8 shadow-lg border border-neutral-200" data-testid="plan-faq">
    <div className="flex items-center gap-2">
      <HelpCircle className="text-green-600" size={20}/>
      <h2 className="text-base md:text-lg font-bold">Billing & plan questions</h2>
    </div>
    <Accordion type="single" collapsible className="mt-3">
      {buildFaqs(byId).map(([q, a], i) => (
        <AccordionItem key={q} value={`faq-${i}`} className="border-neutral-200">
          <AccordionTrigger className="text-left text-sm md:text-base font-semibold hover:no-underline hover:text-green-700" data-testid={`plan-faq-q-${i}`}>{q}</AccordionTrigger>
          <AccordionContent className="text-sm text-neutral-600 leading-relaxed" data-testid={`plan-faq-a-${i}`}>{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
